import { router } from "@inertiajs/react";

const PERIODS: { key: string; label: string }[] = [
  { key: "90d", label: "90 días" },
  { key: "12m", label: "12 meses" },
  { key: "all", label: "Todo" },
];

export function PeriodChips({
  period,
  hrefFor,
}: {
  period: string;
  hrefFor: (period: string) => string;
}) {
  return (
    <div
      className="flex rounded-xl border border-border bg-background p-1"
      role="tablist"
      aria-label="Periodo"
    >
      {PERIODS.map((item) => {
        const selected = period === item.key;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={selected}
            disabled={selected}
            onClick={() =>
              router.get(hrefFor(item.key), {}, { preserveState: true, preserveScroll: true })
            }
            className={`min-h-11 min-w-0 flex-1 rounded-lg px-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-100 ${
              selected
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-accent hover:text-foreground active:bg-accent"
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
